export default __webpack_public_path__ + "c35e75684affc807a41f476037ec6a2c.png";